var dosage_change_reasons = [
  {'value': 'physician_preference', 'label': 'Doktor tercihi'},
  {'value': 'intolerability', 'label': 'İntolerabilite'},
  {'value': 'toxicity', 'label': 'Toksisite'}
];

export { dosage_change_reasons as options };
